import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../../../../msalConfig";
import { DATABOOK_API, TELEMETRY_API } from "../../../../constants/serverConfig";
import { Card, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../../../AuthContext";
import _ from "lodash";
import axios from "axios";
import BreadcrumbBar from "./IndividualDataTabs/BreadcrumbBar";
import IndividualMainTab from "./IndividualDataTabs/IndividalMainTab";
import Footer from "../../../Footer/Footer";
import ReusableHeader from "../../../../utils/ReUsableComponents/ReusableHeader";
import { toast } from "react-toastify";
import { EDIT_SENSITIVITY_DATABOOK_USER, EDIT_SENSITIVITY_DATAEXCELLENCE_USER } from "../../../../constants/Constant";
import { NavBarAndLandingPageContext } from "../../../../NavBarContextAndLandingPageContext";
import LANDINGSECTION from "../../../../constants/LandingConstant";
import DatasetFieldsEditModel from "./IndividualDataTabs/DatasetFieldsEditModel";
import withReactContent from "sweetalert2-react-content";
import moment from "moment";
import Swal from "sweetalert2";

const IndividualPage = () => {
  const location = useLocation();
  let locationfrom = location?.state;

  const [data, setData] = useState([]);
  const [modaldata, setModalData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [metric, setMetric] = useState([]);
  const [bardata, setBarData] = useState([]);
  const [id, setId] = useState();
  const [certifiedetails, setCertifiedDatasets] = useState({});
  const [fqn, setFqn] = useState("");
  const [desctoggle, setDescToggle] = useState(false);
  const [toggleloading, setToggleLoading] = useState(false);
  const [editaccessflag, setEditAccess] = useState(false);
  const [maskedcolumns, setMaskedColumns] = useState([]);
  const [detailCardshow, setDetailCardShow] = useState(false);
  const [datasetModelShow, setDatasetModalFlag] = useState(false);
  const [securityclassification, setSecurityClassification] = useState([]);
  const [valuedesc, setValue] = useState('');

  const params = useParams();

  const { getToken, token, error } = useContext(AuthContext);
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.databook.scopes,
    account: account,
  };
  const { setSearchKeyword } = useContext(NavBarAndLandingPageContext);
  const COLUMN_API = `${DATABOOK_API}/datasets/${params.id}`;
  let navigate = useNavigate();

  const [datasetOwner, setDatasetOwner] = useState([]);
  const [businessOwner, setBusinessOwner] = useState([]);
  const [technologyOwner, setTechnologyOwner] = useState([]);
  const [editDatasetOwnerFlag, setEditDatasetOwner] = useState(false);
  const [editBusinessOwnerFlag, setEditBusinessOwnerFlag] = useState(false);
  const [editTechnologyOwnerFlag, setEditTechnologyOwnerFlag] = useState(false);

  const [fieldDefaultValues, setFieldDefaultValues] = useState([]);
  const [selectedfield, setSelectedField] = useState([]);
  const [fieldname, setFieldName] = useState("");
  const [selectedclassification, setSelectedClassification] = useState([]);
  const [selectedsensitivity, setSelectedSensitivity] = useState([]);
  const [sensitivityDefaultValues, setSensitivityDefaultValues] = useState([]);
  const [sensitivity, setSensitivity] = useState([]);
  const [datasetstage, setDatasetTags] = useState([]);
  const [qualfetching, setqualFetching] = useState(false);
  const [qualdata, setqualData] = useState([]);
  const [description, setDatasetDescription] = useState("");

  const sweetAlertHandler = (alert) => {
    const MySwal = withReactContent(Swal);

    MySwal.fire({
      title: alert.title,

      icon: alert.icon,

      footer: alert.footer,

      confirmButtonColor: "#0ca0ce",

      allowOutsideClick: false,
    });
  };
  const callapiwithtoken = async (callback) => {
    (async () => await getToken())();
    if (token) {
      await callback(token);
    }
    if (error) {
      try {
        const rtoken = (await instance.acquireTokenRedirect(request))
          .accessToken;
        await callback(rtoken);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const backToLandingPage = () => {
    setSearchKeyword({
      criteria: "dataset-name",
      term: ""
    })
    navigate(LANDINGSECTION.DATABOOK_LANDING_URL)
  }

  const getExpectation = (exp) => {
    return (
      exp &&
      exp.map((expectation) => {
        return {
          label: (
            <span>
              {expectation.metric ? expectation.metric : ""} -
              {expectation.operation ? expectation.operation : ""}
              {expectation.value ? expectation.value : ""}
            </span>
          ),
          value: expectation.metric,
        };
      })
    );
  };

  const getProfilers = (ana) => {
    return (
      ana &&
      ana.map((analyzer) => {
        return {
          label: analyzer.metric ? analyzer.metric : "",
          value: analyzer.metric,
        };
      })
    );
  };

  const checkUserEditAccess = (datasetDetail) => {
    let businessOwner = datasetDetail.businessOwner ? datasetDetail.businessOwner : [];
    let engineeringManager = datasetDetail.engineeringManager ? datasetDetail.engineeringManager : [];
    let datasetowner = datasetDetail.owner ? datasetDetail.owner : [];
    // let buis = datasetDetail.owner ? datasetDetail.owner : [];
    // let datasetowner = datasetDetail.owner ? datasetDetail.owner : [];
    let editaccessusers = [
      ...businessOwner,
      ...engineeringManager,
      ...datasetowner,
      ...EDIT_SENSITIVITY_DATABOOK_USER,
      ...EDIT_SENSITIVITY_DATAEXCELLENCE_USER
    ];

    let username = account.username;
    const edituserlist = editaccessusers.filter(str => str.toLowerCase().includes(username.toLowerCase()))
    if (edituserlist.length > 0) {
      setEditAccess(true);
    }
  }

  const getallcolumndata = async (token) => {
    setIsFetching(true);
    axios
      .get(COLUMN_API, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        let maindata = res.data;
        setCertifiedDatasets((maindata.dataset?.certification) ? maindata.dataset?.certification : {
          certificationDate: "",
          certifiedBy: "",
          certifiedFlag: false
        });
        checkUserEditAccess(maindata?.dataset);


        let columndata = [];
        let maskingcolumns = [];
        _.map(maindata.dataset["columns"], (cols) => {
          if (cols.colDatatype?.indexOf("double") > -1 ||
            cols.colDatatype?.indexOf("float") > -1 ||
            cols.securityClassification?.toLowerCase().indexOf("confidential") > -1) {
            maskingcolumns.push(cols.name)
          }
          let profilesdata = getProfilers(cols.analyzers);
          return columndata.push({
            name: cols.name,
            id: cols.id,
            col_datatype: cols.colDatatype,
            description: cols.description === null ? "" : cols.description,
            tags: cols.tags === null ? "" : cols.tags,
            sensitivity: cols.sensitivity,
            analyzers: _.map(cols.analyzers, "metric"),
            expectations: cols.expectations,
            metric: _.map(cols.expectations, "metric"),
            dataset_id: params.id,
            validationdrop: getExpectation(cols.expectations),
            profilersdrop: profilesdata,
            profilersdropdefaultValue: profilesdata ? profilesdata[0] : "",
            versionId: maindata.dataset["versionId"],
            business: maindata.dataset["business"],
            securityClassification: cols.securityClassification,
          });
        });

        let modaldata = maindata.dataset;


        const desc = modaldata["description"];
        const datasetdata = modaldata["id"];
        setMaskedColumns(maskingcolumns);
        setModalData(modaldata);
        setData(columndata);
        setFqn(modaldata["fqn"]);
        setValue(desc);
        setId(datasetdata);
        setIsFetching(false);
      });
  };



  useEffect(() => {
    const fetchData = async () => {
      (async () => await getToken())();
      if (token) {
        await getallcolumndata(token);
      }
      if (error) {
        try {
          const rtoken = (await instance.acquireTokenRedirect(request))
            .accessToken;
          await getallcolumndata(rtoken);
        } catch (error) {
          console.log(error);
        }
      }
    };

    fetchData();
  }, [getToken, token, params.id]);

  const addQualityIdex = ({ qualityIndex }) => {
    setBarData(qualityIndex.bardata);
    setMetric(qualityIndex.metricclr);
  };

  const updateCertificationDetails = (toggleflag) => {
    setToggleLoading(true);
    const inprogresstoast = toast.info(
      "Updating certify details.Please wait..."
    );
    let username = account.username;

    let requestbody = {
      certification: {
        certificationDate: new Date().toISOString(),
        certifiedBy: username,
        certifiedFlag: toggleflag,
      },
      id: modaldata.fqn,
    };

    (async () => await getToken())();
    if (token) {
      axios
        .put(`${DATABOOK_API}/datasets`, requestbody, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          getallcolumndata(token);
          toast.update(inprogresstoast, {
            render: "Certification detail updated successfully.",
            type: toast.TYPE.SUCCESS,
            autoClose: 6000,
            closeButton: true,
            isLoading: false,
          });
          setToggleLoading(false);
        })
        .catch((error) => {

          if (error.response.status == 401) {
            toast.update(inprogresstoast, {
              render: error.response.data,
              type: toast.TYPE.ERROR,
              autoClose: 6000,
              closeButton: true,
              isLoading: false
            });
            setCertifiedDatasets(certifiedetails);
          } else {
            toast.update(inprogresstoast, {
              render: "Some went wrong while updating certification detail.",
              type: toast.TYPE.ERROR,
              autoClose: 6000,
              closeButton: true,
              isLoading: false,
            });
          }
          setToggleLoading(false);

        });
    }
  };

  const savedescription = async (value) => {
    const inprogresstoast = toast.info(
      "Updating description details.Please wait..."
    );
    let requestbody = {
      description: value,
      id: fqn,
    };

    (async () => await getToken())();
    if (token) {
      axios
        .put(`${DATABOOK_API}/datasets`, requestbody, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          setDescToggle(!desctoggle);
          getallcolumndata(token);
          toast.update(inprogresstoast, {
            render: "Dataset description updated successfully.",
            type: toast.TYPE.SUCCESS,
            autoClose: 6000,
            closeButton: true,
            isLoading: false,
          });
        })
        .catch((error) => {
          setDatasetDescription(valuedesc);
          if (error.response.status == 401) {
            toast.update(inprogresstoast, {
              render: error.response.data,
              type: toast.TYPE.ERROR,
              autoClose: 6000,
              closeButton: true,
              isLoading: false
            });
            setDescToggle(false);
          } else {
            toast.update(inprogresstoast, {
              render: "Something went wrong while updating dataset description.",
              type: toast.TYPE.ERROR,
              autoClose: 6000,
              closeButton: true,
              isLoading: false,
            });
          }


        });
    }
  };

  const showModal = (name) => {
    switch (name) {
      case "tags":
        const tagsDefaultValues = modaldata?.tags?.map((item) => ({
          label: item.tagName,
          value: item.fqn,
        }));
        setFieldDefaultValues(tagsDefaultValues);
        const tagselectedefault = [];
        modaldata?.tags?.forEach((item) => {
          tagselectedefault.push(
            ...datasetstage.filter((x) => x.value === item.fqn)
          );
        });
        setSelectedField(
          tagselectedefault.map((item) => ({
            tagName: item.label,
            fqn: item.value,
          }))
        );
        // props.setModalFlag(true);
        setDatasetModalFlag(true);
        setFieldName(name);
        break;
      case "securityClassification":
        setdefaultvalues();
        // props.setModalFlag(true);
        setDatasetModalFlag(true);
        setFieldName(name);
        break;

      case "sensitivity":
        setdefaultvalues();
        // props.setModalFlag(true);
        setDatasetModalFlag(true);
        setFieldName(name);
        break;

      case "owner":
        setEditDatasetOwner(true);
        setDatasetOwner(modaldata.owner || []);
        setDatasetModalFlag(true);
        setFieldName(name);
        break;

      case "Businessowner":
        setEditBusinessOwnerFlag(true);
        setBusinessOwner(modaldata.businessOwner || []);
        setDatasetModalFlag(true);
        setFieldName(name);
        break;

      case "Techowner":
        setEditTechnologyOwnerFlag(true);
        setTechnologyOwner(modaldata.technologyOwner || []);
        setDatasetModalFlag(true);
        setFieldName(name);
        break;

      case "description":
        setFieldDefaultValues([modaldata.description || ""]);
        setSelectedField([modaldata.description || ""]);
        setDatasetModalFlag(true);
        setFieldName(name);
        break;

      default:
        break;
    }
  };

  const setdefaultvalues = () => {
    let classification = modaldata?.securityClassification;
    let defaultClassification = [];
    if (classification) {
      classification?.map((item) => {
        defaultClassification.push(
          ...securityclassification.filter((x) => x.value?.toLowerCase() === item?.toLowerCase())
        );
      });
      setFieldDefaultValues(defaultClassification);
    }
    setSelectedField(classification);
    setSelectedClassification(defaultClassification?.map((item) => item.value));
    if (modaldata?.sensitivity?.length > 0) {
      var defaultselectedSensitivity = sensitivity?.filter(function (el) {
        return modaldata.sensitivity?.indexOf(el.value) >= 0;
      });
      setSelectedSensitivity(
        defaultselectedSensitivity?.map((item) => item.value)
      );
      setSensitivityDefaultValues(defaultselectedSensitivity);
    }
  };

  const fetchAllTags = (token) => {
    axios
      .get(`${DATABOOK_API}/tag-classification/tags`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        let result = res.data?.tags.map((item) => {
          if (item.fqn !== null) {
            return { value: item.fqn, label: item.tagName };
          }
        });
        setDatasetTags(result);
      });
  };

  const getSecurityClassification = async (token) => {
    axios
      .get(
        `${DATABOOK_API}/glossary-classification/terms/classification/SecurityClassification`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        let result = res.data?.glossaryTerms.map((item) => {
          if (item.fqn !== null) {
            return { value: item.fqn, label: item.termName };
          }
        });
        setSecurityClassification(result);
      });
  };
  const getSelectSensitivity = (token) => {
    let classification = modaldata?.securityClassification;
    try {
      const fetchCarouselPromises = modaldata.securityClassification?.map(
        (classification) =>

          axios.get(
            `${DATABOOK_API}/glossary-classification/terms/${classification}/terms`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            }
          )
      );
      if (fetchCarouselPromises) {
        Promise.all(fetchCarouselPromises).then((values) => {
          let container = [];
          values.map((res) => {
            res.data.glossaryTerms.map((item) =>
              container.push({ value: item.fqn, label: item.termName })
            );
          });
          setSensitivity(container);
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const getqualitydata = () => {
    const QUALITY_METRICS = `${TELEMETRY_API}metrics/quality/historical?dataset_name=${params.id}&metric_key=score&runs=10`;
    setqualFetching(true);
    axios.get(QUALITY_METRICS).then((res) => {
      let maindata = res.data;
      let filteriddata = _.filter(
        maindata["metrics"],
        (iddata) => iddata.datasetName === `${params.id}`
      );
      let qualdatas = [];
      _.map(filteriddata, (da) => {
        let unixupdatedate = moment.unix(da.batchDate);
        return qualdatas.push({
          datasetName: da.datasetName,
          metricValue: parseFloat(da.metricValue).toFixed(2),
          updatedAt: unixupdatedate.format("MMM D, YYYY"),
          metricclr: da.metricValue > 90 ? "HIGH" : "LOW",
        });
      });

      const today = new Date();
      const date = moment(today);
      let todaydate = date.format("MMM D, YYYY");

      let qualdataspecific = _.filter(
        qualdatas,
        (qu) => qu["updatedAt"] === todaydate
      );
      let parsedqualdata = _.map(qualdataspecific, "metricValue");
      let metriccolor = _.map(qualdataspecific, "metricclr");

      // const { addQualityIdex } = props;
      let newobj = { bardata: parsedqualdata, metricclr: metriccolor };
      addQualityIdex({ qualityIndex: newobj });
      qualdatas.sort(
        (objA, objB) =>
          Number(new Date(objA.updatedAt)) - Number(new Date(objB.updatedAt))
      );
      setqualFetching(false);
      setqualData(qualdatas);
    });
  };
  useEffect(() => {
    const fetchdatasets = async () => {
      try {
        const token = (await instance.acquireTokenSilent(request)).accessToken;
        getqualitydata(token);
      } catch (error) {
        if (error) {
          try {
            const token = (await instance.acquireTokenRedirect(request))
              .accessToken;
            getqualitydata(token);
          } catch (error) {
            sweetAlertHandler({
              title: "Error while fetching the data. ",
              icon: "info",
            });
          }
        }
      }
    };
    // fetchdatasets();
    if (Object.keys(modaldata)?.length > 0) {
      callapiwithtoken(fetchAllTags);
      callapiwithtoken(getSecurityClassification);
      callapiwithtoken(getSelectSensitivity);
    }

  }, [modaldata]);

  // fetchdatasets();
  //    callapiwithtoken(fetchAllTags);
  //    callapiwithtoken(getSecurityClassification);
  //    callapiwithtoken(getSelectSensitivity);
  //  }, [instance, params.id]);

  const closeModal = (flag) => {
    setSelectedClassification([]);
    setSelectedSensitivity([]);
    // props.setModalFlag(flag);
    setDatasetModalFlag(flag);
    callapiwithtoken(getSelectSensitivity);
  };

  const validateFields = () => {
    return selectedclassification?.filter(
      (item) => item?.indexOf("confidential") > -1
    );
  };

  const editsaveDatasetFields = () => {
    if (fieldname === "securityClassification" || fieldname === "sensitivity") {
      if (
        (validateFields()?.length > 0 && selectedsensitivity?.length === 0) ||
        (selectedclassification?.length === 0 &&
          selectedsensitivity?.length > 0)
      ) {
        toast.info("Security classificaton or sensitivity cannot be blank. ", {
          position: "top-right",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      }
    }

    const inprogresstoast = toast.info(
      "Updating dataset fields. Please wait..."
    );
    let requestbody = "";
    if (fieldname === "owner") {
      requestbody = {
        id: modaldata?.fqn,
        owner: datasetOwner,
      };
    } else if (fieldname === "tags") {
      requestbody = {
        id: modaldata?.fqn,
        tags: selectedfield,
      };
    } else if (fieldname === "securityClassification" || fieldname === "sensitivity") {
      requestbody = {
        id: modaldata?.fqn,
        securityClassification: selectedclassification,
        sensitivity: selectedsensitivity,
      };
    } else if (fieldname === "Businessowner") {
      requestbody = {
        id: modaldata?.fqn,
        businessOwner: businessOwner.map((owner) => `${owner}`),
      };
    } else if (fieldname === "Techowner") {
      requestbody = {
        id: modaldata?.fqn,
        technologyContact: technologyOwner.map((owner) => `${owner}`),
      };
    } else if (fieldname === "description") {
      requestbody = {
        id: modaldata?.fqn,
        description: selectedfield,
      };
    }
    axios
      .put(`${DATABOOK_API}/datasets`, requestbody, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        getallcolumndata(token);
        setDatasetModalFlag(false);
        toast.update(inprogresstoast, {
          render: "Dataset field updated successfully.",
          type: toast.TYPE.SUCCESS,
          autoClose: 6000,
          closeButton: true,
          isLoading: false,
        });
      })
      .catch((error) => {
        if (error.response.status == 401) {
          toast.update(inprogresstoast, {
            render: error.response.data,
            type: toast.TYPE.ERROR,
            autoClose: 6000,
            closeButton: true,
            isLoading: false,
          });
          closeModal();
        }
      });
  };
  const getSensitivityForClassification = (selectedSecurity) => {
    let allterms = [];

    selectedSecurity.map((classification) => {
      axios
        .get(
          `${DATABOOK_API}/glossary-classification/terms/${classification}/terms`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((res) => {
          allterms = [...allterms, ...res.data.glossaryTerms];
          let result = allterms.map((item) => {
            if (item.fqn !== null) {
              return { value: item.fqn, label: item.termName };
            }
          });
          setSelectedSensitivity([]);
          setSensitivity(result);
        });
    });
  };
  const editDatasetOwnerHandler = (e) => {
    let ownerlist = e.target.value.split(",");
    setDatasetOwner(ownerlist);
  };
  const handleBusinessOwnerChange = (e) => {
    const owners = e.target.value.split(",").map((owner) => owner.trim());
    setBusinessOwner(owners);
  };

  const handleTechOwnerChange = (e) => {
    const owners = e.target.value.split(",").map((owner) => owner.trim());
    setTechnologyOwner(owners);
  };

  return (
    <>
      {" "}
      <div className="container__prop">
        <div className="grey__bg">
          <BreadcrumbBar
            datasetdata={data}
            bardata={bardata}
            metricclr={metric}
            from={locationfrom?.from ? locationfrom.from : ""}
            backToLandingPage={backToLandingPage}
            saviyantacess={false}
            modaldata={modaldata}
          />
          <Row>
            <Col sm={12} md={12} lg={12} xl={12} xxl={12}>
              <ReusableHeader
                modaldata={modaldata}
                id={id}
                certifiedetails={certifiedetails}
                savedescription={savedescription}
                setDescToggle={setDescToggle}
                desctoggle={desctoggle}
                value={valuedesc}
                // setValue={setValue}
                description={description}
                setDatasetDescription={setDatasetDescription}
                toggleloading={toggleloading}
                updateCertificationDetails={updateCertificationDetails}
                showModal={showModal}
                datasetId={params.id}
              />
            </Col>
          </Row>
        </div>

        <Card className="view__card">
          <IndividualMainTab
            data={data}
            fetching={isFetching}
            modal={modaldata}
            param={params.id}
            addQualityIdex={addQualityIdex}
            getallcolumndata={getallcolumndata}
            certifiedetails={certifiedetails}
            updateCertificationDetails={updateCertificationDetails}
            toggleloading={toggleloading}
            // editaccessflag={editaccessflag}
            maskedcolumns={maskedcolumns}
            detailCardshow={detailCardshow}
            setDetailCardShow={setDetailCardShow}
            show={datasetModelShow}
            setModalFlag={setDatasetModalFlag}
            sensitivity={sensitivity}
            securityclassification={securityclassification}
            datasetstage={datasetstage}
          />
        </Card>
        {/* <Footer /> */}

        <DatasetFieldsEditModel
          show={datasetModelShow}
          name={fieldname}
          datasetstage={datasetstage}
          detaildata={modaldata}
          setSelectedField={setSelectedField}
          editsaveDatasetFields={editsaveDatasetFields}
          fieldDefaultValues={fieldDefaultValues}
          securityclassification={securityclassification}
          setSelectedClassification={setSelectedClassification}
          getSensitivityForClassification={getSensitivityForClassification}
          sensitivity={sensitivity}
          setSelectedSensitivity={setSelectedSensitivity}
          selectedsensitivity={selectedsensitivity}
          sensitivityDefaultValues={sensitivityDefaultValues}
          closeModel={closeModal}
          editDatasetOwnerFlag={editDatasetOwnerFlag}
          datasetOwner={datasetOwner}
          businessOwner={businessOwner}
          technologyOwner={technologyOwner}
          editDatasetOwnerHandler={editDatasetOwnerHandler}

          editBusinessOwnerHandler={handleBusinessOwnerChange}
          editTechnologyOwnerHandler={handleTechOwnerChange}
        />
      </div>
    </>
  );
};

export default IndividualPage;
